/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class SecurityMatrixService extends services.DataService<Wars.Domain.Model.SecurityMatrix> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService, private $http: angular.IHttpService, private modalService: any) {
            super(injectedBreeze, $q);
        }

        public createSecurityMatrix(isSystemLevel: boolean, alwaysVisible?: boolean): Wars.Domain.Model.SecurityMatrix {
            let obj = this.internalCreateSecurityMatrix(isSystemLevel, alwaysVisible);
            obj.matrixType = Wars.Domain.Model.Codes.Enums.SecurityMatrixType.HideOrShow;
            obj.usesAnotherSecurityMatrix = false;
            return obj;
        }

        private internalCreateSecurityMatrix(isSystemLevel: boolean, alwaysVisible?: boolean): Wars.Domain.Model.SecurityMatrix {
            var obj = this.createNewEntity<Wars.Domain.Model.SecurityMatrix>("SecurityMatrix");
            obj.isSystemLevel = isSystemLevel;
            obj.uniqueIdentifier = services.UtilityService.generateGuidComb();
            if (alwaysVisible) {
                obj.alwaysVisible = alwaysVisible;
            } else {
                obj.alwaysVisible = false;
            }
            return obj;
        }

        public getSystemLevelSecurityMatrices(): angular.IPromise<Wars.Domain.Model.SecurityMatrix[]> {
            const query = this.breezeModule.EntityQuery
                .from("SecurityMatrixs")
                .where('systemLevel_id', '!=', null);

            return this.executeQuery(query);
        }

        public getProcessConfigurationSecurityMatrices(processConfigurationId: string): angular.IPromise<Wars.Domain.Model.SecurityMatrix[]> {
            const query = this.breezeModule.EntityQuery
                .from("SecurityMatrices")
                .where('processConfiguration_id', '==', processConfigurationId)
                .expand('claimBindings');

            return this.executeQuery(query);
        }

        public createAdvancedSecurityMatrix(isSystemLevel: boolean, alwaysVisible?: boolean): Wars.Domain.Model.SecurityMatrix {
            let obj = this.internalCreateSecurityMatrix(isSystemLevel, alwaysVisible);

            obj.matrixType = Wars.Domain.Model.Codes.Enums.SecurityMatrixType.HideOrReadOnlyOrUpdateable;
            obj.usesAnotherSecurityMatrix = false;

            return obj;
        }

        public createSecurityRow(isSystemLevel: boolean, alwaysVisible?: boolean): Wars.Domain.Model.SecurityMatrix {
            let obj = this.internalCreateSecurityMatrix(isSystemLevel, alwaysVisible);

            obj.matrixType = Wars.Domain.Model.Codes.Enums.SecurityMatrixType.SecurityRow;
            obj.usesAnotherSecurityMatrix = false;

            return obj;
        }

        public createSecurityRowWithSubTypes(isSystemLevel: boolean,alwaysVisible?: boolean): Wars.Domain.Model.SecurityMatrix {
            let obj = this.internalCreateSecurityMatrix(isSystemLevel, alwaysVisible);

            obj.matrixType = Wars.Domain.Model.Codes.Enums.SecurityMatrixType.SecurityRowWithSubType;
            obj.usesAnotherSecurityMatrix = false;

            return obj;
        }

        public openSecurityMatrixModal(securityMatrix: Wars.Domain.Model.SecurityMatrix,
            processConfigurationId: string,
            currentStateUniqueId?: string) {
            var self = this;

            this.modalService.showModal({
                    templateUrl: "./app/views/modals/securityMatrixModal.html",
                    controller: "securityMatrixModalController",
                    inputs: {
                        processConfigurationId: processConfigurationId,
                        securityMatrix: securityMatrix,
                        currentStateUniqueId: currentStateUniqueId
                    }
                })
                .then(modal => {
                    modal.element.modal();

                    modal.close.then(result => {
                        $('.modal-backdrop')
                            .each(function() {
                                $(this).remove();
                            });

                        if (result) {
                            self.saveAllChanges();
                        } else {
                            self.rejectChanges();
                        }
                    });
                });
        }

        public getSecurityMatrixView(securityMatrixId: string): ng.IPromise<Wars.Domain.Model.Dtos.SecurityMatrixViewDto> {
            var params: any = {};
            var handlerUrl = "api/SecurityMatrix/" + securityMatrixId + "/View";

            var result: ng.IPromise<any> = this.$http.get(handlerUrl, params)
                .then((response: any): ng.IPromise<any> => this.handlerResponded(response, params));

            return result;
        }

        public openViewSecurityMatrixModal(securityMatrixId: string) {
            
            this.modalService.showModal({
                templateUrl: "./app/views/modals/viewSecurityMatrixModal.html",
                controller: "viewSecurityMatrixModalController",
                size: 'lg',
                inputs: {
                    securityMatrixId: securityMatrixId
                }
            }).then(modal => {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(result => {});
                });
        }

        public handlerResponded(response: any, params: any): any {
            response.data.requestParams = params;
            return response.data;
        }
    }
}

warsApp.registerService('SecurityMatrixService', ['breeze', '$q', "$http", 'ModalService']);